"use client";

import Image from "next/image";
import Button from "@components/atoms/Button";
import { Modal } from "@components/atoms/Modal";
import Text from "@components/atoms/Text";
import {
  INSURANCE_COVER,
  INSURANCE_COVER_CONTENT,
} from "@constants/insuranceCover";
import assetLoader from "@utils/internalImageLoder";
import { useIsMobile } from "@hooks/use-mobile";
import styles from "./styles.module.scss";

interface InsuranceCoverInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function InsuranceCoverInfoModal({
  isOpen,
  onClose,
}: InsuranceCoverInfoModalProps) {
  const standardContent = INSURANCE_COVER_CONTENT[INSURANCE_COVER.STANDARD];
  const extendedContent = INSURANCE_COVER_CONTENT[INSURANCE_COVER.EXTENDED];
  const isMobile = useIsMobile();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      overlayClassName={styles.overlay}
      contentClassName={styles.content}
      headerClassName={styles.header}
      // closeButtonClassName={styles.closeButton}
      bodyClassName={styles.body}
      title="Compare Standard and Extended cover"
      closeIconSize={24}
    >
      <div className={styles.scrollArea}>
        <div className={styles.compareCard}>
          <div className={styles.compareGrid}>
            <div className={styles.compareHeader}>Coverage type</div>
            <div className={styles.compareHeaderCenter}>
              <span>Standard</span>
              <span>cover</span>
            </div>
            <div className={styles.compareHeaderHighlight}>
              <span>Extended</span>
              <span>Cover</span>
            </div>

            {standardContent.compareRows.map((row) => (
              <div className={styles.compareRow} key={row.label}>
                <div className={styles.compareLabel}>{row.label}</div>
                <div className={styles.compareValue}>{row.standard} <span> year</span></div>
                <div className={styles.compareValueHighlight}>{row.extended}<span> year</span></div>
              </div>
            ))}
          </div>

          <div className={styles.noteBox}>
            <Text className={styles.noteText}>
              {standardContent.defaultPlanNote}
            </Text>
          </div>
        </div>

        <div className={styles.section}>
          <Text className={styles.sectionLabel}>What you&apos;ll get</Text>

          <div className={styles.benefits}>
            {extendedContent.modalItems.map((item) => (
              <div key={item.title} className={styles.benefitItem}>
                <div className={styles.benefitIconWrap}>
                  <Image
                    src={`${assetLoader()}${item.image}`}
                    alt=""
                    width={56}
                    height={56}
                    className={styles.benefitIcon}
                  />
                </div>
                <div className={styles.benefitContent}>
                  <Text className={styles.benefitTitle}>{item.title}</Text>
                  <Text className={styles.benefitDescription}>
                    {item.description}
                  </Text>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {isMobile && (
        <Button className={styles.actionButton} onClick={onClose}>
          Okay
        </Button>
      )}
    </Modal>
  );
}
